import { matchPath } from 'react-router-dom';
import { routes } from 'routes';
import type { RootStore } from 'stores/RootStore';

/**
 * `SideOverlayContainer` and `CompactMessengerPanel` sit next to deal routes, not inside
 * `<Route path=".../:dealId" />`, so `useParams()` does not expose `dealId`. Thread sync and
 * `buildDealMessengerChatSource` need the same id segment as `DealPage` / `useCompactMessengerDealThreadSync`.
 */
export const resolveDealIdForMessengerHostOverlays = (pathname: string, store: RootStore): string | null => {
  const dealsRoot = routes.dealsPath();
  const partnerDealsRoot = routes.pDealsPath();

  const dealsMatch = matchPath<{ dealId: string }>(pathname, {
    path: `${dealsRoot}/:dealId`,
    exact: false,
  });

  if (dealsMatch?.params.dealId) return dealsMatch.params.dealId;

  const pDealsMatch = matchPath<{ dealId: string }>(pathname, {
    path: `${partnerDealsRoot}/:dealId`,
    exact: false,
  });

  if (pDealsMatch?.params.dealId) return pDealsMatch.params.dealId;

  /** Do not reuse `dealStore` off deal URLs — avoids wrong thread sync when navigating away from deals. */
  const isUnderDealScopedPath = pathname.startsWith(`${dealsRoot}/`) || pathname.startsWith(`${partnerDealsRoot}/`);

  if (!isUnderDealScopedPath) return null;

  const { id } = store.dealStore.data;

  if (id && Number(id) > 0) return String(id);

  return null;
};
